export default __webpack_public_path__ + "static/media/gallery_00.fe9d6f5b.jpg";